export const DEFAULT_CONFIDENCE_THRESHOLD = 0.6;

export const PROVIDER_NORMALISATION_MAP: Record<string, string> = {
  "open-router": "openrouter",
  or: "openrouter",
  oai: "openai",
  "open-ai": "openai",
  claude: "anthropic",
  ant: "anthropic",
  gemini: "google",
  gcp: "google",
  "google-ai": "google",
  vertex: "google",
  meta: "meta-llama",
  llama: "meta-llama",
  "mistral-ai": "mistral",
  "cohere-ai": "cohere",
};

export const LOCAL_PROVIDERS = new Set([
  "ollama",
  "lmstudio",
  "lm-studio",
  "localai",
  "local-ai",
  "llamacpp",
  "llama.cpp",
  "llamafile",
  "jan",
  "koboldcpp",
]);

export const PROVIDER_INFERENCE_MAP: Array<{
  pattern: RegExp;
  provider: string;
  notes?: string;
}> = [
  { pattern: /^gpt-/, provider: "openai" },
  { pattern: /^o1($|-)/, provider: "openai" },
  { pattern: /^o3($|-)/, provider: "openai" },
  { pattern: /^o4($|-)/, provider: "openai" },
  { pattern: /^chatgpt-/, provider: "openai" },
  { pattern: /^text-davinci/, provider: "openai" },
  { pattern: /^dall-e/, provider: "openai" },
  { pattern: /^whisper/, provider: "openai" },
  { pattern: /^tts-/, provider: "openai" },
  { pattern: /^claude-/, provider: "anthropic" },
  { pattern: /^gemini-/, provider: "google" },
  { pattern: /^palm-/, provider: "google" },
  { pattern: /^bison/, provider: "google" },
  { pattern: /^llama-?[23]/, provider: "meta-llama" },
  { pattern: /^llama/, provider: "meta-llama" },
  { pattern: /^codellama/, provider: "meta-llama" },
  { pattern: /^mistral-/, provider: "mistral" },
  { pattern: /^mixtral-/, provider: "mistral" },
  { pattern: /^codestral/, provider: "mistral" },
  { pattern: /^ministral/, provider: "mistral" },
  { pattern: /^command-/, provider: "cohere" },
  { pattern: /^c4ai-/, provider: "cohere" },
  { pattern: /^deepseek-/, provider: "deepseek" },
  { pattern: /^grok-/, provider: "x-ai" },
  { pattern: /^qwen/, provider: "qwen" },
  { pattern: /^yi-/, provider: "01-ai" },
  { pattern: /^sonar/, provider: "perplexity" },
  { pattern: /^pplx-/, provider: "perplexity" },
  { pattern: /^titan-/, provider: "amazon" },
  { pattern: /^nova-/, provider: "amazon" },
];
